import axios from "axios";
import React, { useEffect, useState } from "react";
import { SERVER_URL } from "../constant";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import AlertBox from "../component/AlertBox";
import DialogBox from "../component/DialogBox";
import ButtonCompo from "../component/ButtonCompo";
import { GoFile } from "react-icons/go";
import { MdOutlineFileDownload } from "react-icons/md";
import { Link } from "react-router-dom";

function EmployeeHRDocument() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [policies, setPolicies] = useState([]);

  // fetch company data
  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/company/get`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployeeData(res.data?.data);
      setPolicies(res.data?.data?.policies);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Employee fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getEmployee();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] lg:w-[50rem] py-5">
          <div className="w-full">
            <div className="w-full mt-5">
              <h3 className="font-medium text-[25px]">Company Policies</h3>
              {policies === undefined || policies?.length === 0 ? (
                <div className="w-full flex justify-center items-center flex-col mt-5">
                  <p className="font-medium text-slate-400 mb-3">
                    No documents added yet
                  </p>
                </div>
              ) : (
                <div className="w-full flex justify-center items-center flex-col mt-5">
                  <Table>
                    <TableBody className="border">
                      {policies?.map((e, i) => (
                        <TableRow>
                          <TableCell>
                            <div className="flex gap-3 items-center">
                              <span className="bg-slate-200/50 p-2 rounded-full">
                                <GoFile className="text-[20px] text-slate-800" />
                              </span>
                              <div>
                                <p className="font-medium">{e?.title}</p>
                                <p className="text-slate-500">
                                  {e?.description}
                                </p>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <span className="bg-slate-200/70 px-3 py-1 rounded-full text-slate-700 font-medium">
                              {new Date(e?.date).toLocaleDateString("en-US", {
                                timeZone: "Asia/Kolkata",
                              })}
                            </span>
                          </TableCell>
                          <TableCell>
                            <Link
                              className="flex gap-2 items-center font-medium px-2 text-blue-600/90 justify-center py-2"
                              to={`${SERVER_URL}/api/v1/file/view/${e?.doc}`}
                              target="_blank"
                            >
                              <MdOutlineFileDownload size={"20px"} /> Download
                            </Link>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeHRDocument;
